import React from 'react'

import { Route } from 'wouter'
import type { RoutesInfo } from 'routes/types'

const LifeCancellation = React.lazy(() => import('../pages/cancellation'))
const LifeCancellationSurvey = React.lazy(() => import('../pages/cancellationSurvey'))
const LifeCancellationRevision = React.lazy(() => import('../pages/cancellationRevision'))
const LifeCancellationReceipt = React.lazy(() => import('../pages/cancellationReceipt'))

export const LifeRoutesInfo: Record<string, RoutesInfo> = {
  cancelLife: { path: '/life/cancellation' },
  surveyLife: { path: '/life/cancellation/survey' },
  revisionLife: { path: '/life/cancellation/revision' },
  receiptLife: { path: '/life/cancellation/receipt' },
}

export const LifeModule: React.FC = () => (
  <>
    <Route path={LifeRoutesInfo.cancelLife.path} component={LifeCancellation} />
    <Route path={LifeRoutesInfo.surveyLife.path} component={LifeCancellationSurvey} />
    <Route path={LifeRoutesInfo.revisionLife.path} component={LifeCancellationRevision} />
    <Route path={LifeRoutesInfo.receiptLife.path} component={LifeCancellationReceipt} />
  </>
)
